import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-5" }
const _hoisted_2 = { class: "w-full md:w-60 h-fit sticky md:fixed bg-white p-5 rounded-md shadow-md border-b-2 border-h-primary-500 select-none" }
const _hoisted_3 = { class: "text-lg font-bold truncate capitalize" }
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = { class: "flex flex-col w-full md:ml-64 gap-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "flex flex-col gap-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("i", {
          class: "pi pi-arrow-left cursor-pointer hover:bg-h-primary-500 hover:text-white transition-all p-1 rounded-full",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.go(-1)), ["prevent"]))
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.list.title), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.links, (link, i) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: i,
          class: "my-2"
        }, [
          _createElementVNode("li", {
            id: link.linkId,
            class: _normalizeClass(`cursor-pointer transition-all hover:scale-95 text-h-primary-500 py-1 pl-3 ${
            _ctx.selected.linkId === link.linkId
              ? 'bg-h-secondary-50 border-l-4 border-h-secondary-600'
              : ''
          }`),
            onClick: ($event: any) => (_ctx.scrollMeTo(link.linkId, i))
          }, _toDisplayString(link.name), 11, _hoisted_4)
        ]))
      }), 128))
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createElementVNode("div", {
        class: "px-10 h-52 rounded-md shadow-md flex items-center text-white gap-14 bg-no-repeat bg-cover bg-center",
        style: _normalizeStyle(_ctx.bgImage(_ctx.banner?.background))
      }, [
        _createElementVNode("img", {
          src: _ctx.banner?.icon,
          class: "w-32 h-auto"
        }, null, 8, _hoisted_6),
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.banner?.title), 1)
      ], 4),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ])
  ]))
}